import ApiService from "service/Api";
import { CatalogGiftPayloadTypes } from "utilities/types/CatalogGift";

const CatalogGiftService = {
  getAllCatalogGifts: async (
    catalogId: string | undefined,
    page: number,
    search: string,
    limit: number
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        catalog_id: catalogId,
        search: search,
        page: page,
        per_page: limit,
        portal: "admin",
      },
      url: "admin/catalogs/gifts",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  getAllCatalogGiftDetails: async (
    checkoutId: string,
    page: number,
    search: string,
    limit: number
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        search: search,
        page: page,
        per_page: limit,
        portal: "admin",
      },
      url: "admin/catalogs/gifts/" + checkoutId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeCatalogGift: async (
    catalogId: string | undefined,
    payload: CatalogGiftPayloadTypes
  ) => {
    const { users } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        catalog_id: catalogId,
        users: users,
      },
      url: "admin/catalogs/gifts",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default CatalogGiftService;
